import React, { Component } from "react";

import { colors } from "assets";

import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Subheader from "material-ui/Subheader";
import Paper from "material-ui-next/Paper";
import {
  DataTable,
  Loadable,
  Page,
  StyledButton,
  CheckBox
} from "components/support";

import Modal from "./custom-fields/modal";

import styles from "./styles";

class ManageFieldsView extends Component {
  config = () => {
    const { presenter } = this.props;

    return {
      identifier: "id",
      columns: [
        {
          id: "fields",
          accessor: "field",
          Header: "Campo",
          align: "center",
          sortable: false,
          filterable: false
        },
        {
          id: "required",
          accessor: "required",
          Header: "Obrigatório",
          align: "center",
          sortable: false,
          filterable: false,
          Cell: props => (
            <CheckBox
              checked={props.original.required}
              onCheck={checked =>
                presenter.handleChangeCheckBox("required", props.index, checked)
              }
              style={{ padding: 0, margin: "0px 0px 0px 9px" }}
              checkBoxStyle={{ border: `1px solid ${colors.primary.normal}` }}
              disabled={props.original.show ? false : true}
            />
          )
        },
        {
          id: "show",
          Header: "Exibir",
          align: "center",
          sortable: false,
          filterable: false,
          Cell: props => (
            <CheckBox
              checked={props.original.show}
              onCheck={checked =>
                presenter.handleChangeCheckBox("show", props.index, checked)
              }
              style={{ padding: 0, margin: "0px 0px 0px 9px" }}
              checkBoxStyle={{ border: `1px solid ${colors.primary.normal}` }}
            />
          )
        }
      ]
    };
  };

  render() {
    const { presenter, viewModel, className } = this.props;
    const { fields, loading, visible, customFields } = viewModel;
    const canSave = fields.some(field => {
      return (
        ["name", "identification", "email"].includes(field.key) &&
        field.required
      );
    });

    return (
      <Page otherClassName={className}>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              Configuração de Campos
            </Typography>
          </Col>

          <Col>
            <StyledButton
              accent
              label="Informações Personalizadas"
              onClick={() => presenter.onOpenModal()}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Paper elevation={1}>
              <Loadable loading={loading}>
                <Subheader>
                  Marque pelo menos um dos três: Nome, Identificação ou E-mail.
                  <br />
                </Subheader>

                <DataTable
                  manual
                  filterable={false}
                  resultSet={fields}
                  showPagination={false}
                  config={this.config()}
                />
              </Loadable>
            </Paper>
          </Col>
        </Row>
        <Row className="buttons">
          <Col xs={12}>
            <Row end="xs">
              <StyledButton
                label="Cancelar"
                onClick={() => presenter.onGoBack()}
                flat
              />

              <StyledButton
                label="Salvar Configuração"
                onClick={() => presenter.onSendForm()}
                primary
                disabled={!canSave}
              />
            </Row>
          </Col>
        </Row>
        <Modal
          visible={visible}
          onClose={updatedFields => presenter.onCloseModal(updatedFields)}
          customerCustomFields={customFields}
        />
      </Page>
    );
  }
}

export default styles(ManageFieldsView);



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/manage-fields/view.jsx